import moment from 'moment'
import { delay, fail, getScenario } from './rewardsMock'

// HO-TASK-286: datos simulados de los referidos, con el contrato REAL del
// backend (RewardReferralController en la rama HO-TASK-275-rewards-api). Solo
// se usan en desarrollo.
//
// GET /rewards/referrals -> { data: {
//   referral_code, rewarded_this_month,
//   referrals: [{ id, email, status, hc_awarded, raffle_tickets, qualified_at, rewarded_at }]
// } }
// `status`: pending | qualified | rewarded | rejected. Fechas en 'YYYY-MM-DD'.
// La lista no viene paginada y va del más reciente al más antiguo.
//
// OJO: hoy `email` llega COMPLETO desde la API; la vista lo enmascara (ver
// maskEmail en rewardsUtils.js) y se pidió al backend que lo enmascare él.
//
// Escenarios, además de 'empty' y 'error' de rewardsMock.js:
//   localStorage.setItem('rewardsMockScenario', 'capped') // referido calificado sin premiar por el tope mensual

const REFERRAL_CODE = 'A1B2C3D4'

const day = (daysAgo) => moment().subtract(daysAgo, 'days').format('YYYY-MM-DD')

const REFERRALS = [
  { id: 14, email: 'junta.resvalleverde@gmail.com', status: 'pending', hc_awarded: 0, raffle_tickets: 5, qualified_at: null, rewarded_at: null },
  { id: 11, email: 'administracion@torreelparque.com', status: 'rewarded', hc_awarded: 1000, raffle_tickets: 5, qualified_at: day(12), rewarded_at: day(12) },
  { id: 9, email: 'mp@hotmail.com', status: 'rejected', hc_awarded: 0, raffle_tickets: 0, qualified_at: null, rewarded_at: null },
  { id: 6, email: 'condominio.losapamates@gmail.com', status: 'rewarded', hc_awarded: 1000, raffle_tickets: 5, qualified_at: day(70), rewarded_at: day(70) }
]

// Tope mensual (3 en el seeder) ya alcanzado: el último referido calificó
// pero quedó sin premiar.
const CAPPED = [
  { id: 17, email: 'jcaraballo@yahoo.com', status: 'qualified', hc_awarded: 0, raffle_tickets: 5, qualified_at: day(0), rewarded_at: null },
  { id: 16, email: 'admin@resmirador.com', status: 'rewarded', hc_awarded: 1000, raffle_tickets: 5, qualified_at: day(0), rewarded_at: day(0) },
  { id: 15, email: 'juntacondominio.elsol@gmail.com', status: 'rewarded', hc_awarded: 1000, raffle_tickets: 5, qualified_at: day(0), rewarded_at: day(0) }
]

export const mockReferrals = () => {
  const scenario = getScenario()
  if (scenario === 'error') return fail()

  if (scenario === 'empty') {
    return delay({ data: { referral_code: REFERRAL_CODE, rewarded_this_month: 0, referrals: [] } })
  }

  const referrals = scenario === 'capped' ? [...CAPPED, ...REFERRALS] : REFERRALS
  const rewardedThisMonth = referrals.filter(
    (referral) => referral.status === 'rewarded' && moment(referral.rewarded_at).isSame(moment(), 'month')
  ).length

  return delay({
    data: {
      referral_code: REFERRAL_CODE,
      rewarded_this_month: rewardedThisMonth,
      referrals
    }
  })
}
